import { render, staticRenderFns } from "./ApplePromotionWebPopup.vue?vue&type=template&id=22e98711&scoped=true"
import script from "./ApplePromotionWebPopup.vue?vue&type=script&lang=js"
export * from "./ApplePromotionWebPopup.vue?vue&type=script&lang=js"
import style0 from "./ApplePromotionWebPopup.vue?vue&type=style&index=0&id=22e98711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e98711",
  null
  
)

export default component.exports